'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgNight(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props },
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("path", { d: "M2 2h12v12H2z" }),
            React__default.default.createElement("path", { d: "M8 2c3.321 0 6 2.679 6 6s-2.679 6-6 6a5.99 5.99 0 01-6-6c0-3.321 2.679-6 6-6zm0 1.5A4.49 4.49 0 003.5 8 4.49 4.49 0 008 12.5c.324 0 .64-.034.944-.098C7.262 11.97 6 10.163 6 8c0-2.163 1.262-3.97 2.943-4.402A4.562 4.562 0 008 3.5z", fill: "currentColor" }))));
}

module.exports = SvgNight;
//# sourceMappingURL=Night.js.map
